import { useEffect } from "react";
import { produce } from "immer";

const RefactorDataStructure = ({ setAttributes, attributes }) => {
  const { autoplay, autoHideControl, muted, options, playinline, preload, resetOnEnd, ratio, repeat, radius, styles, seekTime, speed, width, chapters, imported, controls } =
    attributes;

  const { overlay, overlayBackground, overlayFontSize: fz, overlayLink, overlayOpacity, overlayPosition, overlayText, overlayTextColor, overlayType, overlayLogo } = attributes;

  const {
    captionEnabled,
    CDURL,
    isCDURL,
    endscreen,
    endscreenText,
    endscreenTextLink,
    endScreen,
    vastTag,
    features,
    overlayFontSize,
    thumbInPause,
    watermark,
    popup,
    popupBtnStyle,
    popupBtnText,
    popupBtnClass,
    popupBtnExists,
    autoplayWhenVisible,
    popupType,
    disablePause,
    startTime,
    hideYoutubeUI,
  } = attributes;

  const handleStyles = () => {
    let newStyles = {};
    if (!width.isDeprecated) {
      newStyles = produce(styles, (draft) => {
        draft.plyr_wrapper = {
          width: width.number + width.unit,
        };
        draft.plyr = {
          borderRadius: radius.number + radius.unit,
        };
      });
    }
    return newStyles;
  };

  const handleOptions = () => {
    const newOptions = produce(options, (draft) => {
      draft.preload = preload;
      draft.controls = Object.keys(controls).filter((key) => controls[key]);
      draft.autoplay = autoplay;
      draft.playsinline = playinline;
      draft.seekTime = seekTime;
      draft.muted = muted;
      draft.captions.active = captionEnabled;
      draft.ratio = ratio;
      draft.resetOnEnd = resetOnEnd;
      draft.hideControls = autoHideControl;
      draft.loop.active = repeat;
      draft.speed.options = Object.keys(speed);
      draft.ads.enabled = true;
      draft.ads.tagUrl = vastTag;
      draft.urls.enabled = isCDURL;
      draft.urls.download = CDURL;
      draft.markers = {
        enabled: true,
        points: chapters.map((chapter) => ({ time: chapter.time, label: chapter.name })),
      };
      draft.imported = true;
    });
    return newOptions;
  };

  const handleFeatures = () => {
    const featuresCopy = produce(features, (draft) => {
      draft.popup = {
        enabled: popup,
        selector: popupBtnClass,
        hasBtn: popupBtnExists,
        type: popupType,
        btnText: popupBtnText,
        align: "center",
        btnStyle: {
          color: popupBtnStyle.color,
          backgroundColor: popupBtnStyle.backgroundColor,
          fontSize: popupBtnStyle.fontSize,
          padding: popupBtnStyle.padding,
        },
      };
      draft.overlay = {
        enabled: overlay,
        items: [
          {
            color: overlayTextColor,
            backgroundColor: overlayBackground,
            fontSize: overlayFontSize,
            link: overlayLink,
            logo: overlayLogo,
            text: overlayText,
            position: overlayPosition,
            type: overlayType ? "text" : "logo",
            opacity: overlayOpacity,
          },
        ],
      };
      draft.endScreen = {
        enabled: endscreen,
        text: endscreenText,
        btnText: endScreen.btnText,
        btnLink: endscreenTextLink,
        btnStyle: endScreen.btnStyle,
      };
      draft.thumbInPause = {
        enabled: thumbInPause,
        type: "default",
      };
      draft.watermark = {
        ...watermark,
        color: "#f00",
      };
      draft.sticky = {
        enabled: false,
        position: "top_right",
      };

      draft.playWhenVisible = autoplayWhenVisible;
      draft.disablePause = disablePause;
      draft.hideYoutubeUI = hideYoutubeUI;
      draft.startTime = startTime;
    });

    return featuresCopy;
  };

  useEffect(() => {
    if (!imported) {
      setAttributes({ styles: { ...styles, ...handleStyles() }, width: { ...width, isDeprecated: true }, options: handleOptions(), features: handleFeatures(), imported: true });
    }
  }, []);

  return <></>;
};

export default RefactorDataStructure;
